import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AppComponent} from "../../app.component";
import {MustMatch, PasswordRegex} from "../../const/utils";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {RouterLinks} from "../../enums/router-links";
import {ModalTypes} from "../../enums/modal-types";
import {ModalTemplates} from "../../enums/modal-templates";

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./password-reset.component.less']
})
export class PasswordResetComponent implements OnInit {
  resetForm!: FormGroup;
  submitted = false;
  global_texts: any = null;
  page_texts: any = null;

  constructor(
    public app: AppComponent,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute
  ) {
    // this.router.events.subscribe((event) => {
    //   if (event instanceof NavigationEnd) {
    //     this.initializeComponentReset();
    //   }
    // });
  }

  get f() {
    return this.resetForm.controls;
  }

  ngOnInit(): void {
    this.initializeComponentReset();
  }

  initializeComponentReset() {
    // Get the global texts
    this.app.sharedHelper.getGlobalTexts().subscribe((texts: any) => {
      console.log("texts ==> ", texts);
      this.global_texts = texts;
      this.page_texts = this.global_texts.password_reset_page;
      console.log("this.page_texts ==> ", this.page_texts);

      // Initialize the form
      this.resetForm = this.formBuilder.group({
        password: ['', [Validators.required, Validators.pattern(PasswordRegex)]],
        confirm_password: ['', [Validators.required, Validators.pattern(PasswordRegex)]]
      });

      // Add the custom validator for the form
      this.resetForm.setValidators(MustMatch('password', 'confirm_password'));
    });
  }

  getToken() {
    let token = '';
    this.route.queryParams.subscribe(params => {
      token = params['token'];
    });
    return token;
  }

  onSubmit() {
    // Display the form values
    console.log("this.resetForm.value ==> ", this.resetForm.value);
    this.submitted = true;

    // Stop here if form is invalid
    if (this.resetForm.invalid) return;

    this.app.apiService.resetPassword(this.getToken(), this.resetForm.value.password).subscribe((response: any) => {
      console.log("response ==> ", response);
      if (response?.data) {
        // Show modal with success message
        this.app.dialogService.confirmThis('', this.global_texts.modals?.password_reseted?.message, ModalTypes.Alert, ModalTemplates.Default, () => {
          // Redirect to login page
          this.router.navigate([RouterLinks.Login]);
        }, () => {});
      }
    });
  }

}
